import { useState, useEffect } from 'react';
import { Image, Typography } from 'antd';
import classnames from 'classnames';
import {
  convertTiffBase64ToPreview,
  mapOriginalFileTypeToImage,
  isImageType,
} from 'utils/fileType';
import WithLoading from 'common/components/wrapper/WithLoading';

const MAX_IMAGE_SIZE_MB = 20;

const ImagePreview = ({ selectedItemPreview, fileList }) => {
  const [displaySrc, setDisplaySrc] = useState();
  const [isConverting, setIsConverting] = useState(false);
  const [isFileTooLarge, setIsFileTooLarge] = useState(false);

  useEffect(() => {
    const imageData = selectedItemPreview?.imageData;
    const fileName = fileList[fileList.length - 1]?.name;

    // Reset states
    setIsFileTooLarge(false);
    setIsConverting(false);

    if (!imageData) {
      setDisplaySrc(null);
      return;
    }

    // Check if current file is an image type
    const isImage = isImageType(fileName);

    const sizeInBytes = (imageData.length * 3) / 4;
    const sizeInMB = sizeInBytes / (1024 * 1024);

    if (isImage && sizeInMB > MAX_IMAGE_SIZE_MB) {
      setIsFileTooLarge(true);
      setDisplaySrc(
        mapOriginalFileTypeToImage(fileList[fileList.length - 1]?.name)
      );
      return;
    }

    // Check if it's a TIFF file
    const isTiff =
      imageData?.includes('data:image/tiff') ||
      imageData?.includes('data:image/tif');

    if (isTiff) {
      setIsConverting(true);

      // Convert TIFF to PNG preview
      convertTiffBase64ToPreview(imageData)
        .then((pngDataUrl) => {
          setDisplaySrc(pngDataUrl);
        })
        .catch((error) => {
          setDisplaySrc(imageData);
        })
        .finally(() => {
          setIsConverting(false);
        });
    } else {
      // Not a TIFF, use original
      setDisplaySrc(imageData);
    }
  }, [selectedItemPreview?.imageData, fileList]);

  return (
    <WithLoading loading={isConverting}>
      <div style={{ width: '100%', height: '100%' }}>
        {displaySrc && (
          <Image
            className={classnames(
              'upload-file__preview-image',
              'upload-file__preview-image--fade-in',
              {
                'upload-file__preview-image--fileType':
                  !displaySrc?.includes('data:image') || isFileTooLarge,
              }
            )}
            src={displaySrc}
            fallback={mapOriginalFileTypeToImage(
              fileList[fileList.length - 1]?.name
            )}
          />
        )}
      </div>
      {isFileTooLarge && (
        <div
          style={{
            marginTop: '12px',
            textAlign: 'center',
            color: '#ff4d4f',
            fontSize: '14px',
          }}
        >
          <Typography.Text strong type='warning' style={{ color: '#faad14' }}>
            Image Too Large to Preview
          </Typography.Text>
        </div>
      )}
    </WithLoading>
  );
};

export default ImagePreview;
